import { Tooltip } from '@mui/material'
import { useTranslation } from 'react-i18next'

import type { CustomChipProps } from '@/components/dataDisplay/CustomChip'
import CustomChip from '@/components/dataDisplay/CustomChip'
import { getPhaseChipProps } from '@/features/prequalification/localControl/utils/phasePresentation'
import type { AggregatePhase } from '@/features/prequalification/types'

type PqPhaseChipProps = {
  phase: AggregatePhase
  size?: 'small' | 'medium'
  /**
   * Context the label can't carry on its own — currently when a `SCHEDULED` run starts.
   * Build it with `phaseChipTooltip`; omit it and the chip renders bare.
   */
  tooltipTitle?: string
}

function PqPhaseChip({ phase, size = 'medium', tooltipTitle }: Readonly<PqPhaseChipProps>) {
  const { t } = useTranslation()
  const { label, color, icon, inactive } = getPhaseChipProps(phase, t)

  const chipProps: Partial<CustomChipProps> = inactive
    ? { variant: 'outlinedInactive', icon, label }
    : { variant: 'outlined', color, icon, label }

  const chip = <CustomChip size={size} sx={{ textTransform: 'uppercase' }} {...chipProps} />

  if (!tooltipTitle) return chip

  // CustomChip is a plain function component, so the tooltip anchors to a span rather
  // than the chip itself — the same wrapping the list grid's market chips use.
  return (
    <Tooltip title={tooltipTitle}>
      <span>{chip}</span>
    </Tooltip>
  )
}

export default PqPhaseChip
